<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span>路由策略管理</span>
        </div>
      </h3>
    </el-row>
    <!-- 3.工具栏 -->
    <el-row>
      <div class="table-tool">
        <el-form inline size="small" >
          <!-- 日期时间框 -->
          <el-form-item style="margin-right:10px;">
            <el-date-picker
              v-model="startAndEndTime"
              type="datetimerange"
              unlink-panels
              style="width:360px;"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <!-- 下拉 -->
          <el-form-item style="margin-right:10px;margin-top:-1px;">
            <el-select v-model="channelIdList" multiple collapse-tags clearable>
              <el-option
                v-for="item in platforms"
                :key="item.id"
                :label="item.name"
                :value="item.tag"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 搜索内容 -->
          <el-form-item style="margin-right:10px;margin-top:-1px;">
            <el-input
              class="selectInput"
              style="width:250px"
              v-model="searchText"
              placeholder="策略名称/编辑人"
            >
              <svg slot="suffix" class="icon" @click="searchAcd" aria-hidden="true">
                <use xlink:href="#iconsearchicon" />
              </svg>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:-1px;">
            <el-button type="info" @click="addNewAcd" icon="el-icon-plus">新增策略</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
    <!-- 3.表格区 -->
    <el-row>
      <el-table style="width:100%;" :data="tableData">
        <el-table-column prop="acdName" label="策略名称" align="center" :show-overflow-tooltip="true" />
        <el-table-column
          prop="channelsName"
          label="所属渠道"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="editTime"
          label="最后编辑时间"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="editor"
          label="最后编辑人"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="apply"
          align="center"
          label="是否已被调用">
          <template slot-scope="scope">
            <div
              :class="scope.row.apply ? 'text-success' : ''"
              disable-transitions>{{scope.row.apply?'是':'否'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="查看" placement="bottom">
              <el-button
                @click="showAcd(scope.row)"
                type="text"
              >
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#iconxiangqing" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip v-show="canEditAcd(scope.row)" class="item" effect="light" content="编辑" placement="bottom">
              <el-button
                @click="editAcd(scope.row)"
                type="text"
              >
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip v-show="canEditAcd(scope.row)" class="item" effect="light" content="删除" placement="bottom">
              <el-button
                @click="_deleteAcd(scope.row)"
                type="text"
              >
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页栏 -->
      <el-row style="float:right;">
        <el-pagination
          background
          class="pageStyle"
          layout="total, prev, pager, next, jumper"
          :page-size.sync="pageSize"
          :current-page.sync="pageNum"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-row>

    </el-row>
    </el-scrollbar>
  </div>
</template>
<script>
import { getPlatforms, listAcds, deleteAcd, getAcdById } from '@/api/user'
export default {
  name: 'strategyList',
  data() {
    return {
      platforms: [],
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 工具栏
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // 筛选条件
      startAndEndTime: [],
      channelIdList: '',
      searchText: '',
      // 1.表格内数据
      tableData: [],
      defaultAcdId: this.$global.defaultAcdId
    }
  },
  mounted() {
    this._getPlatforms()
    this._listAcds({ startTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[0] : null, endTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[1] : null, channelIds: this.channelIdList.join(','), kwyWord: this.searchText })
  },
  methods: {
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      this._listAcds({ startTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[0] : null, endTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[1] : null, channelIds: this.channelIdList.join(','), kwyWord: this.searchText })
    },
    addNewAcd() {
      this.$store.commit('user/setCanEditAcd', { canEditAcd: true })
      this.$store.commit('user/setAcdCache', { acd: {} })
      this.$store.commit('user/setCurAcdId', { acdId: '' })
      this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 2 })
    },
    _getPlatforms() {
      getPlatforms().then(
        res => {
          if (res.code === 2000) {
            this.platforms = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    _listAcds({ startTime, endTime, channelIds, kwyWord }) {
      listAcds({
        startTime,
        endTime,
        channelIds,
        kwyWord,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(
        res => {
          if (res.code === 2000) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    canEditAcd(row) {
      return !row.apply && row.id !== this.defaultAcdId
    },
    showAcd(row) {
      const acdId = row.id
      this.loadSpecificAcd(acdId)
      this.$store.commit('user/setCanEditAcd', { canEditAcd: false })
    },
    editAcd(row, canEdit) {
      const acdId = row.id
      this.loadSpecificAcd(acdId)
      this.$store.commit('user/setCanEditAcd', { canEditAcd: true })
    },
    loadSpecificAcd(acdId) {
      getAcdById({
        acdId
      }).then(
        res => {
          if (res.code === 2000) {
            this.$store.commit('user/setAcdCache', { acd: res.data })
            this.$store.commit('user/setCurAcdId', { acdId })
            this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 2 })
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    _deleteAcd(row) {
      const acdId = row.id

      this.$confirm('路由策略删除后将无法恢复，请您确认是否需要删除？', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false
      })
        .then(() => {
          deleteAcd({
            acdId
          }).then(
            res => {
              if (res.code === 2000) {
                this.$message.success(res.data)
                this._listAcds({ startTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[0] : null, endTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[1] : null, channelIds: this.channelIdList.join(','), kwyWord: this.searchText })
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        })
        .catch(() => {})
    },
    searchAcd() {
      this.pageNum = 1
      this._listAcds({ startTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[0] : null, endTime: this.startAndEndTime.length === 2 ? this.startAndEndTime[1] : null, channelIds: this.channelIdList.join(','), kwyWord: this.searchText })
    }
  }
}
</script>
<style lang="scss">
 .table-tool{margin:10px 0 4px;}
</style>
<style lang="scss" scoped>
  .wrapper {
    height: 100%;
  }
  .scrollbar-wrap {
    height: calc(100% - 61px - 78px);
  }
</style>
